import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    FloatingActionButton,
    FloatingActionButtons,
} from "../../../components/floatingActionButton";
import * as LayoutActions from "../../layout/actions";
import { ReportActiveFilters } from "../components/ReportActiveFilters";
import { SalesReportTable } from "../components/SalesReportTable";
import { useReportDates } from "../hooks/useReportDates";
import { useReportFilters } from "../hooks/useReportFilters";
import { useReportSales } from "../hooks/useReportSales";
import { useSalesReportData } from "../hooks/useSalesReportData";
import { useSalesReportExcel } from "../hooks/useSalesReportExcel";
import { useSalesReportPdf } from "../hooks/useSalesReportPdf";
import { SalesReportLayout } from "./SalesReportLayout";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const m = defineMessages({
    title: { id: "SalesReportPage.title", defaultMessage: "Sales by client report" },
});

export const SalesReportPage = () => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(LayoutActions.setPageTitle(formatMessage(m.title)));
    }, [dispatch, formatMessage]);

    const { filters, clearFilter } = useReportFilters();

    const { reportMonthsInOrder, currentPeriodEndDate, previousPeriodStartDate } = useReportDates();

    const { salesStat, isLoading: isLoadingSalesStat } = useReportSales(
        previousPeriodStartDate,
        currentPeriodEndDate,
        filters,
    );

    const { salesReportData, isProcessing } = useSalesReportData(
        salesStat,
        filters,
        reportMonthsInOrder,
        previousPeriodStartDate,
        currentPeriodEndDate,
    );

    const isLoading = isLoadingSalesStat || isProcessing;

    const { getDocumentDefinition } = useSalesReportPdf(salesReportData);

    const generatePdf = () => {
        const documentDefinition = getDocumentDefinition();
        pdfMake.createPdf(documentDefinition).download(`${formatMessage(m.title)}.pdf`);
    };

    const { exportToExcelAndDownload } = useSalesReportExcel();

    const exportToExcel = () => exportToExcelAndDownload(salesReportData);

    return (
        <SalesReportLayout>
            <ReportActiveFilters onClear={clearFilter} />
            <SalesReportTable salesReportData={salesReportData} isLoading={isLoading} />
            <FloatingActionButtons>
                <FloatingActionButton icon="file excel outline" onClick={exportToExcel} />
                <FloatingActionButton icon="file pdf" onClick={generatePdf} />
                <FloatingActionButton
                    icon="filter"
                    onClick={() => navigate(`/reports/sales/filters${location.search}`)}
                />
            </FloatingActionButtons>
        </SalesReportLayout>
    );
};
